import { render, staticRenderFns } from "./ViewReturnProduct.vue?vue&type=template&id=c6316a84"
import script from "./ViewReturnProduct.vue?vue&type=script&lang=js"
export * from "./ViewReturnProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports